import styled from 'styled-components';

export const Footer = styled('footer')(({ theme }) => ({
  width: '100%',
  background: theme.colors.darkGoku,
  color: theme.colors.greyText,
  height: 'auto',
  flexShrink: '0',
  padding: '40px 0',
  borderTop: '1px solid',
  borderColor: theme.colors.primaryRed,
}));

export const FooterImages = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '16px',
});

export const FooterText = styled('p')({
  fontSize: '12px',
  fontWeight: '600',
  textAlign: 'center',
});
export const FooterTop = styled('div')({
  width: '100%',
  background: '#3B3B3B',
  padding: '15px 42px',
  display: 'grid',
  gridTemplateColumns: '1fr 2fr 1fr',
  gridTemplateRows: '1fr',
  gridColumnGap: '5px',
  gridRowGap: '0px',
});
